export const FOOTER_QUERY = `Footers {  
    footers{
      data {
        id
        attributes {
            footer_logo {
                logo {
                    data {
                        attributes {
                            name
                            url
                        }
                    }
                }
                TN_certified_logo {
                  data {
                      attributes {
                          name
                          url
                      }
                  }
              }
              }
              navigations {
                id
                menus
              }
              copyrights {
                policy
                rightslink {
                  id
                  label
                  url
                  slug
                }
              }
              contactUs {
                label
                content
              }
        }
      }
    }
  }`;
